export async function preloadAllLazyPages() {
  const imports = [
    import('@views/verifyEmailPage/VerifyEmailPage'),
    import('@views/signInPage/SignInPage'),
    import('@views/signUpPage/SignUpPage'),
    import('@views/forgotPassword/ForgotPassword'),
    import('@views/resetPassword/ResetPasswordPage'),
    import('@views/faqPage/FaqPage'),
    import('@views/homePage/HomePage'),
    import('@views/downloadAppPage/DownloadAppPage'),
    import('@views/documents/DocumentsPage'),
    import('@views/contacts/ContactsPage'),
    import('@views/info/InfoPage'),
    import('@views/questionnairePage/QuestionnairePage'),
    import('@views/checkupStartPage/CheckupStartPage'),
    import('@views/profilePage/ProfilePage'),
    import('@views/myHealth/HealthPage'),
  ];

  await Promise.allSettled(imports);
}
